import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  TextField,
  InputAdornment,
  Tab,
  Tabs,
  Card,
  Avatar,
  Rating,
  Button,
  Grid,
  styled,
  Divider,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  padding: theme.spacing(2),
  height: '100%',
  transition: '0.3s',
  '&:hover': {
    boxShadow: theme.shadows[4],
  },
}));

const AvatarContainer = styled(Box)(({ theme }) => ({
  width: 90,
  height: 90,
  marginRight: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
}));

const DoctorDetails = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  flexWrap: 'wrap',
}));

// const doctors = [
//     {
//       id: 1,
//       name: 'Rodrigo Hartman',
//       specialty: 'Dentist',
//       procedure: 'Dental Scaling & Polishing',
//       hospital: 'National Hospital ABUJA',
//       rating: 4.8,
//       reviews: 10,
//       image: 'https://via.placeholder.com/150/abcdef', // Placeholder image
//     },
//     {
//       id: 2,
//       name: 'Ember Wynn',
//       specialty: 'Pediatric Neurologist',
//       procedure: 'Pediatric Neurology',
//       hospital: 'National Hospital ABUJA',
//       rating: 5.0,
//       reviews: 20,
//       image: 'https://via.placeholder.com/150/123456', // Placeholder image
//     },
//     {
//       id: 3,
//       name: 'Romeo Levy',
//       specialty: 'Cardiologist',
//       procedure: 'Pediatric Cardiologist',
//       hospital: 'National Hospital ABUJA',
//       rating: 4.8,
//       reviews: 12,
//       image: 'https://via.placeholder.com/150/fedcba', // Placeholder image
//     },
//     {
//       id: 4,
//       name: 'Luca Craft',
//       specialty: 'Dentist',
//       procedure: 'Dental Scaling & Polishing',
//       hospital: 'National Hospital ABUJA',
//       rating: 5.0,
//       reviews: 15,
//       image: 'https://via.placeholder.com/150/654321', // Placeholder image
//     },
//     {
//       id: 5,
//       name: 'Ryleigh Berger',
//       specialty: 'Pediatric Neurologist',
//       procedure: 'Pediatric Neurologist',
//       hospital: 'National Hospital ABUJA',
//       rating: 4.8,
//       reviews: 10,
//       image: 'https://via.placeholder.com/150/aabbcc', // Placeholder image
//     },
//   ];

const DoctorListWeb = ({doctors}) => {
  const [selectedTab, setSelectedTab] = React.useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const navigate = useNavigate();

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
    // Filter logic if needed
  };

  return (
    <Box sx={{ p: 3 }}>
      <HeaderContainer>
        <Typography variant="h4" fontWeight="bold">
          Find a Doctor
        </Typography>
        <TextField
          size="small"
          placeholder="Search by name or specialty"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ width: isMobile ? '100%' : 400 }}
        />
      </HeaderContainer>

      <Tabs value={selectedTab} onChange={handleChangeTab} sx={{ mb: 3 }}>
        <Tab label="All" />
        <Tab label="Dentist" />
        <Tab label="Cardiologist" />
        <Tab label="Neurologist" />
      </Tabs>

      <Grid  container sx={{ "&:hover": { cursor: "pointer", backgroundColor:"#f9fdf9" }}} spacing={3}>
        {doctors?.map((doctor) => (
          <Grid onClick={() => navigate(`/profile?cat=doctor&id=${doctor?.id}`)} item  xs={12} sm={6} md={4} lg={3} key={doctor.id}>
            <StyledCard>
              <AvatarContainer>
                <Avatar
                  src={doctor.profilePicture}
                  alt={doctor.name}
                  sx={{ width: '100%', height: '100%' }}
                />
              </AvatarContainer>
              <DoctorDetails >
                <Box>
                  <Typography variant="h6" fontWeight="bold">{`${doctor?.firstName} ${doctor?.lastName}`}</Typography>
                  <Typography variant="body2" color="text.secondary">
                  {doctor.userRoles[0]?.roleSpecialist?.role?.name || ''} — {doctor?.department}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {doctor?.healthCareProvider?.name}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                    <Rating value={doctor.rating} size="small" readOnly />
                    <Typography variant="caption" sx={{ ml: 1 }}>
                      ({doctor.reviews} reviews)
                    </Typography>
                    
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                  <Button onClick={()=>navigate(`/profile?cat=doctor&id=${doctor?.id}`)} variant="outlined" size="small">
                   View
                  </Button>
                  <IconButton>
                    <FavoriteBorderIcon />
                  </IconButton>
                </Box>
              </DoctorDetails>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DoctorListWeb;
